<template>
  <v-form
    ref="form"
    v-model="formValid"
  >
    <v-card>
      <v-card-title>{{ isNewCategory ? 'Add': 'Edit' }} Category</v-card-title>

      <v-card-text class="py-0">
        <v-text-field
          ref="categoryName"
          v-model="category.name"
          :rules="[rules.required, rules.noDuplicateCategories]"
          label="Name*"
          required
        />

        <v-text-field
          ref="categoryGuideUrl"
          v-model="category.guideUrl"
          :rules="[rules.required, (v) => !guideUrlDirty || isUrl(v) || 'Invalid URL.']"
          label="Guide Url*"
          placeholder="e.g. https://openlawdocs.com.au/estate-planning-guide/"
          type="url"
          required
          @blur="guideUrlDirty = true"
        />

        <!-- TODO single expert -->
        <v-select
          ref="expertLawyers"
          v-model="category.expertLawyers"
          :items="lawyers"
          label="Default Expert Lawyers"
          multiple
          item-text="name"
          item-value="id"
          dense
        />

        <v-select
          v-model="category.accountTypes"
          :items="accountTypes"
          label="Account types"
          multiple
          item-text="label"
          item-value="id"
          dense
        />
        <v-textarea
          v-model="category.description"
          auto-grow
          label="Description"
          hint="If specified, then the description will be show in the category on the New Document page"
        />
        <v-text-field
          v-model="category.displayPriority"
          type="number"
          min="1"
          label="Display Priority"
          hint="If specified, the category will be prioritised on the New Document page. Priority 1 will be shown first. Categories with the same priority will be sorted alphabetically."
        />
        <v-switch
          ref="templateActive"
          v-model="category.active"
          label="Active"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          small
          @click="$emit('cancel')"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="!formValid || saving"
          color="primary"
          small
          @click="saveCategory"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { firebase, fsdb } from '../firebase'
import { listAllAccountTypes } from '@/dataAccess/accountTypes'

export default {
  name: 'EditCategory',
  props: {
    selectedCategory: {
      type: Object,
      default: () => ({ '.key': '', name: '', accountTypes: [] })
    },
    appTemplateCategories: { type: Array, default: () => [] },
    lawyers: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      formValid: false,
      formDirty: false,
      category: Object.assign({}, this.selectedCategory),
      guideUrlDirty: false,
      saving: false,
      accountTypes: listAllAccountTypes(),
      rules: {
        noDuplicateCategories: v => {
          var dupeCategory = this.appTemplateCategories.find(
            item =>
              item.name === v &&
              (item['.key'] !== this.category['.key'] ||
                this.category['.key'] === '')
          )
          return typeof dupeCategory === 'undefined'
            ? true
            : 'There is already a category with this name.'
        },
        required: v => !!v || 'This field is required.'
      }
    }
  },
  computed: {
    isNewCategory() {
      return !this.category['.key']
    }
  },
  watch: {
    category: {
      handler: function (newVal) {
        this.formDirty = true
      },
      deep: true
    },
    selectedCategory: {
      handler: function (newVal) {
        const selectedCategory =
          this.selectedCategory && 'name' in this.selectedCategory
            ? this.selectedCategory
            : this.$options.props.selectedCategory.default()
        this.category = Object.assign({}, selectedCategory)
        if (selectedCategory && selectedCategory.created) {
          this.category.created = selectedCategory.created.toDate()
        }
        this.category.expertLawyers = this.category.expertLawyers || []

        if (selectedCategory['.key'] === '') {
          this.$refs.form.reset()
          this.guideUrlDirty = false
        } else {
          this.guideUrlDirty = true
        }
      },
      deep: true
    }
  },
  methods: {
    async saveCategory() {
      this.saving = true
      var category = this.category

      category.created =
        category.created || firebase.firestore.FieldValue.serverTimestamp()
      category.modified = firebase.firestore.FieldValue.serverTimestamp()
      category.modifiedBy = this.$store.state.user.uid
      if (category.displayPriority) {
        category.displayPriority = parseInt(category.displayPriority)
      } else {
        delete category.displayPriority
      }

      try {
        const wasNewCategory = this.isNewCategory
        if (this.isNewCategory) {
          let newCategory = await fsdb
            .collection('templateCategories')
            .add(category)
          this.$emit('categorySaved', newCategory.id)
          this.category['.key'] = newCategory.id
        } else {
          var categoryCopy = { ...category }
          delete categoryCopy['.key']
          await fsdb
            .collection('templateCategories')
            .doc(category['.key'])
            .set(categoryCopy)
        }
        this.$emit('categorySaved', { category: this.category, isNew: wasNewCategory })
      } catch (e) {
        this.$showErrorbar('Error saving Category. Refresh and try again.')
        this.$Sentry.captureException(e)
      }

      this.saving = false
    },
    newCategory() {
      this.category = { '.key': '', name: '', guideUrl: '', accountTypes: [] }
    },
    isUrl(str) {
      return /^(?:\w+:)?\/\/([^ .]+\.\S{2}|localhost[:?\d]*)\S*$/.test(str)
    }
  }
}
</script>
